import { cn } from "@commerce-frontend/ui/helpers/styles";

type Props = {
	children: React.ReactNode;
	isSelected: boolean;
	isDisabled: boolean;
	onClick?: () => void;
};

export const VariantButton = ({ children, isSelected, isDisabled, onClick }: Props) => {
	return (
		<button
			type="button"
			className={cn(
				"relative flex h-12 cursor-pointer select-none items-center justify-center overflow-hidden text-ellipsis rounded-xs bg-gray-50 px-2xl py-lg text-sm font-bold text-brand shadow-1 transition-all",
				"focus:ring-accent-level-2 hover:bg-gray-100 hover:shadow-2",
				isSelected &&
					"bg-orange-dark-200 text-gray-700 shadow-0 hover:bg-orange-dark-200 hover:shadow-0",
				isDisabled &&
					"pointer-events-none text-gray-400 shadow-none before:absolute before:h-full before:w-full before:bg-strikethrough before:content-['']",
			)}
			onClick={onClick}
		>
			{children}
		</button>
	);
};
